import React from "react";
import {
    Button,
    convertInputFormToObject,
    InputForm,
    inputStyles,
    TextField,
    useInputForm,
    SelectField,
} from "../../../../Components/Inputs";
import {clearInputFormFields} from "../../../../Components/Inputs/inputUtility";
import {gridConstants, GridContainer, GridCell} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";
import {braillerHistorySearchModel} from "./braillerHistorySearchFactory";
import {
    BRAILLER_HISTORY_STATUS_OPTIONS,
} from "./braillerHistoryConstants";
import {createListFromArray, createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {isFimcAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface BraillerHistorySearchFormViewProps {
    dropDowns: Record<string, any>;
    handleSetSearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
    searchCriteria: Record<string, any>;
}

export const BraillerHistorySearchFormView = ({
                                                  dropDowns,
                                                  handleSetSearchCriteria,
                                                  isLoading,
                                                  searchCriteria,
                                              }: BraillerHistorySearchFormViewProps) => {
    const searchForm = useInputForm(braillerHistorySearchModel());

    const shippingLocations = createListFromArrayOfObjects(dropDowns.shippingLocations, "shippingLocationId", "name");
    const districts = createListFromArrayOfObjects(dropDowns.districts, "districtId", "districtName");
    const organizations = createListFromArray(dropDowns?.organizations);

    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedSearchCriteria = {...searchCriteria};
        updatedSearchCriteria.ClearBraillerHistorySearch();
        handleSetSearchCriteria(updatedSearchCriteria);
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedSearchCriteria = {...searchCriteria};
        updatedSearchCriteria.Search(criteria);
        handleSetSearchCriteria(updatedSearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.THREE,
    };

    return (
        <>
            <InputForm name="braillerHistorySearch" hasPaddingY>
                <TextField
                    {...searchForm.searchTerm}
                    {...inputSharedSettings}
                    label="Search"
                    placeholder="Title, Model, or Serial Number"
                />

                {dropDowns?.shippingLocations && (
                    <SearchableSingleSelectField
                        {...searchForm.shippingLocationId}
                        {...inputSharedSettings}
                        includeDefaultOption
                        label="Shipping Location"
                        options={shippingLocations}
                    />
                )}

                <SelectField
                    {...searchForm.status}
                    {...inputSharedSettings}
                    label="Status"
                    options={BRAILLER_HISTORY_STATUS_OPTIONS}
                    includeDefaultOption={false}
                />

                {
                    isFimcAdmin() &&
                    <>
                        <SearchableSingleSelectField
                            {...searchForm.districtId}
                            {...inputSharedSettings}
                            includeDefaultOption
                            label={'District'}
                            options={districts}
                        />
                        <SearchableSingleSelectField
                            {...searchForm.organization}
                            {...inputSharedSettings}
                            includeDefaultOption
                            label={'Organization'}
                            options={organizations}
                        />
                    </>
                }
                <GridCell>
                    <GridContainer hasPaddingX isFlush isReverseOrder>
                        <GridCell medium_columns={gridConstants.column.FOUR}>
                            <Button
                                buttonType={inputStyles.button.types.SEARCH}
                                disabled={isLoading}
                                label="Search"
                                name="btnSearchBraillerHistory"
                                onClick={handleSearchClick}
                                isPrimary
                            />
                        </GridCell>

                        <GridCell medium_columns={gridConstants.column.FOUR}>
                            <Button
                                buttonType={inputStyles.button.types.CLEAR}
                                disabled={isLoading}
                                name="btnClearBraillerHistorySearch"
                                onClick={handleClearClick}
                                label="Clear"
                            />
                        </GridCell>
                    </GridContainer>
                </GridCell>
            </InputForm>
        </>
    );
};
